import './index.css'

const ThumbnailItem = props => {
  const {imageDetails, changeImage} = props
  const {id, thumbnailUrl, thumbnailAltText} = imageDetails
  const onClickChangeImage = () => {
    changeImage(id)
  }
  return (
    <li className="list-item">
      <button className="image-btn" type="button" onClick={onClickChangeImage}>
        <img
          src={thumbnailUrl}
          alt={thumbnailAltText}
          className="thumnail-image"
        />
      </button>
    </li>
  )
}
export default ThumbnailItem
